module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/thunder-night-12a964e439e42a2c79ef2cb2fcf8bca6.svg";